import { useSyncExternalStore } from 'react'
import { useQuery } from '@tanstack/react-query'

import { env } from '@/app/env'
import { featureFlagsQueryOptions } from '@/features/feature-flags/api/feature-list'
import {
  getFeatureFlagOverrides,
  subscribeFeatureFlagOverrides
} from '@/features/feature-flags/domain/feature-flag-overrides'
import type { FeatureFlag } from '@/features/feature-flags/domain/feature-flags'

// Reads one per-user feature flag. Returns false while loading, on error, and
// for flags the API didn't send, so gated UI falls back to current behavior.
// Precedence: dev-tools override (Cmd+D → Shift+F) > VITE_FEATURE_OVERRIDES > API.
// A forced value skips the request entirely.
export function useFeature(flag: FeatureFlag) {
  const overrides = useSyncExternalStore(subscribeFeatureFlagOverrides, getFeatureFlagOverrides)
  const runtimeOverride = overrides[flag]
  const forced =
    runtimeOverride === undefined ? env.featureOverrides[flag] : runtimeOverride === 'true'
  const { data } = useQuery({
    ...featureFlagsQueryOptions(),
    enabled: forced === undefined
  })
  if (forced !== undefined) return forced
  return data?.[flag] ?? false
}
